module.exports = "//docs.gtimg.com/slide/img/framework/editor/src/img/pageIndex/stylePanel/item-symbol-1-7269c1.svg";